import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
  },
  subContainer: {
    display: 'flex',
    width: '95%',
    maxHeight: '86vh',
    marginTop: 6,
  },
  table: { paddingX: 2 },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
